const PostVisibilityType = Object.freeze({
    PUBLIC: 0,
    PRIVATE: 1,
    SUBSCRIBERS_ONLY: 2,
  });
export default PostVisibilityType